import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="key-stealer"
export default class extends Controller {
  static targets = ["receiver"]

  redirect(event) {
    event.preventDefault()
    if (this.hasReceiverTarget)
      this.receiverTarget.click()
  }
}
